import React from "react";
import { Link } from "react-router-dom";
import AmenityBox from "../AmenityBox";
import Button from "components/UI/Button";
const amenities = gymAmenities => {
  return gymAmenities.map((currentItem, index, arr) => {
    const classname = currentItem.class_name;
    // const classid = currentItem.class_id;
    const classAmenities = currentItem.amenities.map(currentItem => (
      <div style={{ margin: "10px" }}>
        <AmenityBox label={currentItem.name} source={currentItem.icons.black} />
      </div>
    ));
    return (
      <div style={{ display: "flex", flexDirection: "column" }}>
        <h2>{classname}</h2>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)" }}>
          {classAmenities}
        </div>
      </div>
    );
  });
};

const View = props => {
  const style = {
    Button: {
      width: "200px"
    },
    amenitiesWrapper: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      flexWrap: "wrap",
      marginTop: "20px"
    },
    buttonWrapper: {
      display: "flex",
      justifyContent: "flex-start"
    }
  };
  return (
    <div>
      <div style={style.buttonWrapper}>
        <Link to="/gyms/gym/amenities/edit/">
          <Button type="holo" holo style={style.Button}>
            Edit
          </Button>
        </Link>
      </div>
      <div style={style.amenitiesWrapper}>{amenities(props.gymAmenities)}</div>
    </div>
  );
};

export default View;
